export const familyProfiles = [
  {
    id: 'jeyakumar-p',
    name: 'JEYAKUMAR P',
    photo: '/Family Pics/jeyakumar.PNG',
    dob: '12.06.1973',
    placeOfBirth: 'BODINAYAKANUR',
    sex: 'MALE',
    weight: '65KG',
    height: '162CM',
    bloodGroup: 'B+ve',
    residence: '2/20, Theradi Street, EB Office Road, Bodinayakanur, Theni, TN, India-625513',
    occupation: 'TEACHER',
    familyRole: 'FATHER',
    contact: '9976632471',
    email: 'jeyakumarpaulraj73@gmail.com'
  },
  {
    id: 'viji-p',
    name: 'VIJI JEYAKUMAR',
    photo: '/Family Pics/viji.JPG',
    dob: '06.04.1984',
    placeOfBirth: 'VADUGAPATTI',
    sex: 'FEMALE',
    weight: '68KG',
    height: '165CM',
    bloodGroup: 'O+ve',
    residence: '2/20, Theradi Street, EB Office Road, Bodinayakanur, Theni, TN, India-625513',
    occupation: 'TEACHER',
    familyRole: 'MOTHER',
    contact: '8667264831',
    email: 'vijijeyakumar84@gmail.com'
  },
  {
    id: 'rujai-ananth-j',
    name: 'RUJAI ANANTH J',
    photo: '/Family Pics/rujaiananth.JPG',
    dob: '15.07.2005',
    placeOfBirth: 'KARUR',
    sex: 'MALE',
    weight: '53KG',
    height: '171CM',
    bloodGroup: 'B+ve',
    residence: '2/20, Theradi Street, EB Office Road, Bodinayakanur, Theni, TN, India-625513',
    occupation: 'Founder & CEO of FOZZIL',
    familyRole: 'ELDER SON',
    contact: '9360246273',
    email: 'rujaiananthj@gmail.com'
  },
  {
    id: 'prajit-kannan-j',
    name: 'PRAJIT KANNAN J',
    photo: '/Family Pics/prajit.JPG',
    dob: '09.01.2007',
    placeOfBirth: 'BODINAYAKANUR',
    sex: 'MALE',
    weight: '55KG',
    height: '176CM',
    bloodGroup: 'O+ve',
    residence: '2/20, Theradi Street, EB Office Road, Bodinayakanur, Theni, TN, India-625513',
    occupation: 'STUDENT',
    familyRole: 'YOUNGER SON',
    contact: '9942323271',
    email: 'prajitkannanj@gmail.com'
  },
  {
    id: 'thamoj-karthic-j',
    name: 'THAMOJ KARTHIC J',
    photo: '/Family Pics/thamoj.jpeg',
    dob: '01.11.2011',
    placeOfBirth: 'BODINAYAKANUR',
    sex: 'MALE',
    weight: '30KG',
    height: '150CM',
    bloodGroup: 'B+ve',
    residence: '2/20, Theradi Street, EB Office Road, Bodinayakanur, Theni, TN, India-625513',
    occupation: 'STUDENT',
    familyRole: '2ND YOUNGER SON',
    contact: '6379538355',
    email: 'thamojkarthicj@gmail.com'
  }
];
